module.exports = {
	"ha": "vcha",
	"id": 5.5,
	"report": {
		"ha": "Vancouver Coastal Health",
		"group": "HSDA",
		"period": "2017 Q3–2018 Q2",
		"lastYear": "2018",
		"lastQuarter": "2"
	},
	"globalOptions": {
		"lang": {
			"numericSymbols": null
		}
	},
	"instr": {
		"chart": {
			"plotBackgroundColor": "#e1e2e4",
			"alignTicks": false,
			"width": 950,
			"height": 530,
			"marginTop": 80,
			"marginLeft": 110,
			"style": {
				"fontFamily": "Lato",
				"color": "#2c3e50"
			},
			"type": "column"
		},
		"credits": {
			"enabled": false
		},
		"legend": {
			"enabled": false
		},
		"tooltip": {
			"valueDecimals": 1,
			"valueSuffix": " %"
		},
		"title": {
			"align": "left",
			"x": -10,
			"useHTML": true,
			"text": "<span style=\"display: table;\">                 <span style=\"display: table-cell; min-width: 110px;\">Figure 5.5</span>                 <span style=\"display: table-cell;\">Estimated Cascade of Care for Vancouver Coastal Health by Age Category and MSM Status, Year Ending 2018 Q2 <sup style=\"font-size: 10px;\">9</sup></span>               </span>",
			"style": {
				"fontSize": "14px",
				"color": "#2c3e50"
			}
		},
		"plotOptions": {
			"series": {
				"marker": {
					"enabled": false
				},
				"dataLabels": {
					"allowOverlap": true,
					"useHTML": true,
					"style": {},
					"verticalAlign": "top"
				},
				"pointPadding": 0,
				"groupPadding": 0,
				"stacking": "normal",
				"colorByPoint": true
			},
			"column": {
				"colors": [
					"",
					"#043f61",
					"#0c4250",
					"#0d4440",
					"#09472e",
					"#0a4a23"
				]
			}
		},
		"xAxis": [
			{
				"lineWidth": 0,
				"tickWidth": 0,
				"labels": {
					"reserveSpace": false,
					"rotation": 270,
					"y": -100,
					"align": "left",
					"style": {
						"fontSize": "1.2em",
						"color": "white",
						"textOutline": "0.5px contrast"
					}
				},
				"categories": [
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					"",
					""
				]
			}
		],
		"yAxis": [
			{
				"height": "60%",
				"max": 100,
				"tickPosition": "inside",
				"lineColor": "#231f20",
				"lineWidth": 1,
				"tickColor": "#231f20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#231f20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"title": {
					"text": "% of Diagnosed",
					"margin": -10,
					"x": -30
				},
				"labels": {
					"format": "{value}%"
				},
				"plotLines": [
					{
						"value": 0,
						"color": "black",
						"dashStyle": "solid",
						"width": 1,
						"zIndex": 100
					}
				]
			},
			{
				"top": "60%",
				"height": "40%",
				"tickPosition": "inside",
				"lineColor": "#9e1c20",
				"lineWidth": 1,
				"tickColor": "#9e1c20",
				"tickInterval": 20,
				"minorTickPosition": "inside",
				"minorTickInterval": 10,
				"tickWidth": 1,
				"minorTickWidth": 1,
				"minorTickColor": "#9e1c20",
				"tickLength": 12,
				"minorTickLength": 8,
				"gridLineWidth": 0,
				"minorGridLineWidth": 0,
				"offset": 0,
				"max": 0,
				"min": -60,
				"title": {
					"text": "% Loss from<br>Previous Stage",
					"margin": -10,
					"style": {
						"color": "#9e1c20"
					},
					"x": -30
				},
				"labels": {
					"format": "{value}%",
					"style": {
						"color": "#9e1c20"
					},
					"zIndex": 1
				}
			}
		],
		"series": [
			{
				"name": "% of Diagnosed",
				"yAxis": 0,
				"data": [
					{
						"y": null
					},
					{
						"y": 86.25,
						"dataLabels": {
							"enabled": false,
							"format": "69"
						},
						"color": "#043f61"
					},
					{
						"y": 78.75,
						"dataLabels": {
							"enabled": false,
							"format": "63"
						},
						"color": "#0c4250"
					},
					{
						"y": 77.5,
						"dataLabels": {
							"enabled": false,
							"format": "62"
						},
						"color": "#0d4440"
					},
					{
						"y": 68.75,
						"dataLabels": {
							"enabled": false,
							"format": "55"
						},
						"color": "#09472e"
					},
					{
						"y": 65,
						"dataLabels": {
							"enabled": false,
							"format": "52"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.36842105263158,
						"dataLabels": {
							"enabled": false,
							"format": "296"
						},
						"color": "#043f61"
					},
					{
						"y": 84.21052631578947,
						"dataLabels": {
							"enabled": false,
							"format": "256"
						},
						"color": "#0c4250"
					},
					{
						"y": 80.5921052631579,
						"dataLabels": {
							"enabled": false,
							"format": "245"
						},
						"color": "#0d4440"
					},
					{
						"y": 73.35526315789474,
						"dataLabels": {
							"enabled": false,
							"format": "223"
						},
						"color": "#09472e"
					},
					{
						"y": 65.78947368421053,
						"dataLabels": {
							"enabled": false,
							"format": "200"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 98.8425925925926,
						"dataLabels": {
							"enabled": false,
							"format": "427"
						},
						"color": "#043f61"
					},
					{
						"y": 88.6574074074074,
						"dataLabels": {
							"enabled": false,
							"format": "383"
						},
						"color": "#0c4250"
					},
					{
						"y": 83.56481481481481,
						"dataLabels": {
							"enabled": false,
							"format": "361"
						},
						"color": "#0d4440"
					},
					{
						"y": 78.00925925925925,
						"dataLabels": {
							"enabled": false,
							"format": "337"
						},
						"color": "#09472e"
					},
					{
						"y": 69.9074074074074,
						"dataLabels": {
							"enabled": false,
							"format": "302"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.86149584487535,
						"dataLabels": {
							"enabled": false,
							"format": "1442"
						},
						"color": "#043f61"
					},
					{
						"y": 91.62049861495845,
						"dataLabels": {
							"enabled": false,
							"format": "1323"
						},
						"color": "#0c4250"
					},
					{
						"y": 88.1578947368421,
						"dataLabels": {
							"enabled": false,
							"format": "1273"
						},
						"color": "#0d4440"
					},
					{
						"y": 85.3185595567867,
						"dataLabels": {
							"enabled": false,
							"format": "1232"
						},
						"color": "#09472e"
					},
					{
						"y": 77.63157894736842,
						"dataLabels": {
							"enabled": false,
							"format": "1121"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#043f61"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0c4250"
					},
					{
						"y": 100,
						"dataLabels": {
							"enabled": false,
							"format": "21"
						},
						"color": "#0d4440"
					},
					{
						"y": 90.47619047619048,
						"dataLabels": {
							"enabled": false,
							"format": "19"
						},
						"color": "#09472e"
					},
					{
						"y": 76.19047619047619,
						"dataLabels": {
							"enabled": false,
							"format": "16"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.40259740259741,
						"dataLabels": {
							"enabled": false,
							"format": "150"
						},
						"color": "#043f61"
					},
					{
						"y": 88.31168831168831,
						"dataLabels": {
							"enabled": false,
							"format": "136"
						},
						"color": "#0c4250"
					},
					{
						"y": 78.57142857142857,
						"dataLabels": {
							"enabled": false,
							"format": "121"
						},
						"color": "#0d4440"
					},
					{
						"y": 63.63636363636363,
						"dataLabels": {
							"enabled": false,
							"format": "98"
						},
						"color": "#09472e"
					},
					{
						"y": 47.4025974025974,
						"dataLabels": {
							"enabled": false,
							"format": "73"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.68152866242038,
						"dataLabels": {
							"enabled": false,
							"format": "313"
						},
						"color": "#043f61"
					},
					{
						"y": 92.67515923566879,
						"dataLabels": {
							"enabled": false,
							"format": "291"
						},
						"color": "#0c4250"
					},
					{
						"y": 86.94267515923568,
						"dataLabels": {
							"enabled": false,
							"format": "273"
						},
						"color": "#0d4440"
					},
					{
						"y": 74.84076433121018,
						"dataLabels": {
							"enabled": false,
							"format": "235"
						},
						"color": "#09472e"
					},
					{
						"y": 53.18471337579618,
						"dataLabels": {
							"enabled": false,
							"format": "167"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 99.16897506925207,
						"dataLabels": {
							"enabled": false,
							"format": "716"
						},
						"color": "#043f61"
					},
					{
						"y": 95.29085872576178,
						"dataLabels": {
							"enabled": false,
							"format": "688"
						},
						"color": "#0c4250"
					},
					{
						"y": 90.7202216066482,
						"dataLabels": {
							"enabled": false,
							"format": "655"
						},
						"color": "#0d4440"
					},
					{
						"y": 84.07202216066482,
						"dataLabels": {
							"enabled": false,
							"format": "607"
						},
						"color": "#09472e"
					},
					{
						"y": 67.03601108033241,
						"dataLabels": {
							"enabled": false,
							"format": "484"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 46.788990825688074,
						"dataLabels": {
							"enabled": false,
							"format": "51"
						},
						"color": "#043f61"
					},
					{
						"y": 38.53211009174312,
						"dataLabels": {
							"enabled": false,
							"format": "42"
						},
						"color": "#0c4250"
					},
					{
						"y": 35.77981651376147,
						"dataLabels": {
							"enabled": false,
							"format": "39"
						},
						"color": "#0d4440"
					},
					{
						"y": 33.02752293577982,
						"dataLabels": {
							"enabled": false,
							"format": "36"
						},
						"color": "#09472e"
					},
					{
						"y": 29.357798165137616,
						"dataLabels": {
							"enabled": false,
							"format": "32"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 97.59615384615384,
						"dataLabels": {
							"enabled": false,
							"format": "203"
						},
						"color": "#043f61"
					},
					{
						"y": 78.84615384615384,
						"dataLabels": {
							"enabled": false,
							"format": "164"
						},
						"color": "#0c4250"
					},
					{
						"y": 75.48076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "157"
						},
						"color": "#0d4440"
					},
					{
						"y": 69.23076923076923,
						"dataLabels": {
							"enabled": false,
							"format": "144"
						},
						"color": "#09472e"
					},
					{
						"y": 62.019230769230774,
						"dataLabels": {
							"enabled": false,
							"format": "129"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 94.91017964071857,
						"dataLabels": {
							"enabled": false,
							"format": "317"
						},
						"color": "#043f61"
					},
					{
						"y": 72.75449101796407,
						"dataLabels": {
							"enabled": false,
							"format": "243"
						},
						"color": "#0c4250"
					},
					{
						"y": 70.35928143712576,
						"dataLabels": {
							"enabled": false,
							"format": "235"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.26946107784431,
						"dataLabels": {
							"enabled": false,
							"format": "218"
						},
						"color": "#09472e"
					},
					{
						"y": 58.08383233532935,
						"dataLabels": {
							"enabled": false,
							"format": "194"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					},
					{
						"y": 96.60574412532638,
						"dataLabels": {
							"enabled": false,
							"format": "740"
						},
						"color": "#043f61"
					},
					{
						"y": 72.58485639686684,
						"dataLabels": {
							"enabled": false,
							"format": "556"
						},
						"color": "#0c4250"
					},
					{
						"y": 69.71279373368147,
						"dataLabels": {
							"enabled": false,
							"format": "534"
						},
						"color": "#0d4440"
					},
					{
						"y": 65.79634464751958,
						"dataLabels": {
							"enabled": false,
							"format": "504"
						},
						"color": "#09472e"
					},
					{
						"y": 60.313315926892955,
						"dataLabels": {
							"enabled": false,
							"format": "462"
						},
						"color": "#0a4a23"
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			},
			{
				"name": "% Loss from Previous Stage",
				"yAxis": 1,
				"data": [
					{
						"y": null
					},
					{
						"y": -13.749999999999996,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.695652173913048,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -1.5873015873015928,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.290322580645162,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.454545454545457,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.631578947368418,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.513513513513509,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.296875,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.979591836734691,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.313901345291477,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -1.157407407407407,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.304449648711945,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.744125326370753,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.648199445983383,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.385756676557866,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.13850415512465242,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.252427184466015,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.779289493575211,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.2207384131971772,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.009740259740262,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": 0,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.523809523809524,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -15.789473684210531,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.5974025974025983,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -9.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.029411764705888,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.00826446280992,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -25.510204081632647,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.31847133757961776,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.028753993610226,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -6.185567010309279,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -13.919413919413914,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -28.936170212765955,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -0.8310249307479256,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9106145251396662,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.796511627906974,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.328244274809159,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -20.263591433278417,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": null
					},
					{
						"y": -53.21100917431192,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -17.647058823529417,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.14285714285714,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.692307692307687,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.111111111111116,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -2.4038461538461564,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -19.21182266009852,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -4.268292682926833,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.280254777070063,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -10.416666666666663,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -5.089820359281438,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -23.34384858044164,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.292181069958844,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -7.234042553191489,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -11.009174311926607,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					},
					{
						"y": -3.394255874673624,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -24.864864864864867,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -3.9568345323740983,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -5.61797752808989,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": -8.333333333333337,
						"color": "#e7c8c7",
						"dataLabels": {
							"enabled": false
						}
					},
					{
						"y": null
					}
				],
				"table": {
					"visible": false
				}
			}
		],
		"groups": [
			{
				"x": 12,
				"y": 40,
				"text": "MSM"
			},
			{
				"x": 3,
				"text": "<30<br>n=80"
			},
			{
				"x": 9,
				"text": "30-39<br>n=304"
			},
			{
				"x": 15,
				"text": "40-49<br>n=432"
			},
			{
				"x": 21,
				"text": ">=50<br>n=1444"
			},
			{
				"x": 37,
				"y": 40,
				"text": "Non-MSM"
			},
			{
				"x": 28,
				"text": "<30<br>n=21"
			},
			{
				"x": 34,
				"text": "30-39<br>n=154"
			},
			{
				"x": 40,
				"text": "40-49<br>n=314"
			},
			{
				"x": 46,
				"text": ">=50<br>n=722"
			},
			{
				"x": 62,
				"y": 40,
				"text": "Unknown"
			},
			{
				"x": 53,
				"text": "<30<br>n=109"
			},
			{
				"x": 59,
				"text": "30-39<br>n=208"
			},
			{
				"x": 65,
				"text": "40-49<br>n=334"
			},
			{
				"x": 71,
				"text": ">=50<br>n=766"
			}
		],
		"dataTable": {
			"MSM:<30": [
				80,
				69,
				63,
				62,
				55,
				52
			],
			"MSM:30-39": [
				304,
				296,
				256,
				245,
				223,
				200
			],
			"MSM:40-49": [
				432,
				427,
				383,
				361,
				337,
				302
			],
			"MSM:>=50": [
				1444,
				1442,
				1323,
				1273,
				1232,
				1121
			],
			"Non-MSM:<30": [
				21,
				21,
				21,
				21,
				19,
				16
			],
			"Non-MSM:30-39": [
				154,
				150,
				136,
				121,
				98,
				73
			],
			"Non-MSM:40-49": [
				314,
				313,
				291,
				273,
				235,
				167
			],
			"Non-MSM:>=50": [
				722,
				716,
				688,
				655,
				607,
				484
			],
			"Unknown:<30": [
				109,
				51,
				42,
				39,
				36,
				32
			],
			"Unknown:30-39": [
				208,
				203,
				164,
				157,
				144,
				129
			],
			"Unknown:40-49": [
				334,
				317,
				243,
				235,
				218,
				194
			],
			"Unknown:>=50": [
				766,
				740,
				556,
				534,
				504,
				462
			]
		}
	},
	"callback": "C:\\Users\\Rafael\\Projects\\cfenet.ubc.ca-qmr\\src\\cli/callback.js",
	"outfile": "./temp/png/figure_vcha_5_5.png"
};


//////////////////
// WEBPACK FOOTER
// ./temp/json/figure_vcha_5_5.json
// module id = 305
// module chunks = 0